import { z } from 'zod';
// Create validation and DTO type
export const roleCreateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    description: z.string().nullish(),
    isSystemAdmin: z.boolean().optional(),
    meetingBodyRoleIds: z.array(z.number()).optional(),
});
// Update validation and DTO type
export const roleUpdateSchema = roleCreateSchema.partial();
